export default __webpack_public_path__ + "static/media/Bien-seguro.e70b36b3.svg";